export function toAwsDateTime(value) {
  if (!value) return undefined;                // omit if empty
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();                      // 2025-08-15T17:05:00.000Z
}

export function sanitizeInput(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) =>
      v !== '' && v !== null && v !== undefined && !(typeof v === 'number' && Number.isNaN(v))
    )
  );
}
